import { Action } from '@ngrx/store';

export enum MyEdiaryActionTypes {
  LOAD_EDIARY = '[MyEdiaryAction] Load eDiary',
  LOAD_EDIARY_FAILED = '[MyEdiaryAction] Load eDiary failed',
  LOAD_EDIARY_SUCCESS = '[MyEdiaryAction] Load eDiary success',
  LOAD_EDIARY_PENDING = '[MyEdiaryAction] Load eDiary pending',
  LOAD_EDIARY_DETAIL = '[MyEdiaryAction] Load eDiary detail',
  ADD_TO_CALENDAR = '[MyEdiaryAction] Add to Calendar',
  ADD_TO_CALENDAR_SUCCESS = '[MyEdiaryAction] Add to Calendar success',
  ADD_TO_CALENDAR_FAILED = '[MyEdiaryAction] Add to Calendar failed',
  FIND_AND_ADD_TO_CALENDAR = '[MyEdiaryAction] Find and add to Calendar failed',
  FIND_EVENT_EXISTS = '[MyEdiaryAction] Event exists in Calendar'
}

export class MyEdiaryActionLoadEdiary implements Action {
  readonly type = MyEdiaryActionTypes.LOAD_EDIARY;
}

export class MyEdiaryActionLoadEdiaryFailed implements Action {
  readonly type = MyEdiaryActionTypes.LOAD_EDIARY_FAILED;
}

export class MyEdiaryActionLoadEdiarySuccess implements Action {
  readonly type = MyEdiaryActionTypes.LOAD_EDIARY_SUCCESS;

  constructor(public payload: any) {}
}

export class MyEdiaryActionLoadEdiaryPending implements Action {
  readonly type = MyEdiaryActionTypes.LOAD_EDIARY_PENDING;

  constructor(public payload: boolean) {}
}

export class MyEdiaryActionLoadEdiaryDetail implements Action {
  readonly type = MyEdiaryActionTypes.LOAD_EDIARY_DETAIL;

  constructor(public payload: any) {}
}

export class MyEdiaryActionFindAndAddToCalendar implements Action {
  readonly type = MyEdiaryActionTypes.FIND_AND_ADD_TO_CALENDAR;

  constructor(public payload: any) {}
}

export class MyEdiaryActionAddToCalendar implements Action {
  readonly type = MyEdiaryActionTypes.ADD_TO_CALENDAR;

  constructor(public payload: any) {}
}

export class MyEdiaryActionAddToCalendarSuccess implements Action {
  readonly type = MyEdiaryActionTypes.ADD_TO_CALENDAR_SUCCESS;

  constructor(public payload: any) {}
}

export class MyEdiaryActionAddToCalendarFailed implements Action {
  readonly type = MyEdiaryActionTypes.ADD_TO_CALENDAR_FAILED;
}

export class MyEdiaryActionFindEventExists implements Action {
  readonly type = MyEdiaryActionTypes.FIND_EVENT_EXISTS;
}

export type MyEdiaryActions =
  | MyEdiaryActionLoadEdiary
  | MyEdiaryActionLoadEdiaryFailed
  | MyEdiaryActionLoadEdiarySuccess
  | MyEdiaryActionLoadEdiaryPending
  | MyEdiaryActionLoadEdiaryDetail
  | MyEdiaryActionAddToCalendar
  | MyEdiaryActionAddToCalendarSuccess
  | MyEdiaryActionAddToCalendarFailed
  | MyEdiaryActionFindAndAddToCalendar
  | MyEdiaryActionFindEventExists;
